(function () {
  'use strict';

  if (window.LPLIntroTypewriter && window.LPLIntroTypewriter.boot) {
    window.LPLIntroTypewriter.boot(document);
    return;
  }

  var LINE_PAUSE = [800, 850, 900, 1500, 2600, 0];
  var instances = new WeakMap();
  var segmenter = typeof Intl !== 'undefined' && Intl.Segmenter
    ? new Intl.Segmenter(undefined, { granularity: 'grapheme' })
    : null;

  function characters(text) {
    return segmenter
      ? Array.from(segmenter.segment(text), function (part) { return part.segment; })
      : Array.from(text);
  }

  function init(root) {
    if (instances.has(root)) return;

    var speed = parseFloat(root.dataset.speed);
    if (!Number.isFinite(speed) || speed <= 0) speed = 1.5;
    var startDelay = parseInt(root.dataset.startDelay, 10);
    if (!Number.isFinite(startDelay) || startDelay < 0) startDelay = 1200;

    var link = root.querySelector('.lpl-tw__link');
    var motion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    var state = {
      lines: [],
      lineIndex: 0,
      timers: new Set(),
      destroyed: false,
      finished: false,
      started: false,
      blocked: false,
      caret: null,
      tabindex: link && !root.classList.contains('is-pending') ? link.getAttribute('tabindex') : null,
      ariaDisabled: link && !root.classList.contains('is-pending') ? link.getAttribute('aria-disabled') : null
    };
    instances.set(root, state);
    root.dataset.twInit = '1';

    function clearTimers() {
      state.timers.forEach(function (timer) { window.clearTimeout(timer); });
      state.timers.clear();
    }

    function schedule(callback, delay) {
      var timer = window.setTimeout(function () {
        state.timers.delete(timer);
        if (state.destroyed) return;
        try { callback(); } catch (error) { restore(); }
      }, delay);
      state.timers.add(timer);
    }

    function restoreAttribute(element, name, value) {
      if (value === null) element.removeAttribute(name);
      else element.setAttribute(name, value);
    }

    function unlock() {
      state.blocked = false;
      if (!link) return;
      link.classList.add('is-live');
      restoreAttribute(link, 'tabindex', state.tabindex);
      restoreAttribute(link, 'aria-disabled', state.ariaDisabled);
      link.removeEventListener('click', blockClick, true);
      link.removeEventListener('auxclick', blockClick, true);
    }

    function blockClick(event) {
      if (!state.blocked) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    }

    function removeListeners() {
      window.removeEventListener('resize', positionCaret);
      if (motion) {
        if (motion.removeEventListener) motion.removeEventListener('change', motionChanged);
        else if (motion.removeListener) motion.removeListener(motionChanged);
      }
    }

    function restore() {
      if (state.destroyed) return;
      clearTimers();
      removeListeners();
      state.finished = true;
      state.lines.forEach(function (line) {
        var typed = document.createElement('span');
        typed.setAttribute('data-typed', '');
        typed.setAttribute('aria-hidden', 'true');
        var rest = document.createElement('span');
        rest.setAttribute('data-rest', '');
        rest.setAttribute('aria-hidden', 'true');
        rest.textContent = line.text;
        line.el.replaceChildren(typed, rest);
      });
      if (state.caret) state.caret.remove();
      root.classList.remove('is-pending', 'is-typing');
      unlock();
    }

    function positionCaret() {
      if (state.destroyed || !state.caret || state.caret.classList.contains('is-gone')) return;
      var line = state.lines[state.lineIndex];
      if (!line || !line.chars.length) return;

      var character = line.chars[Math.max(0, line.n - 1)];
      var range = document.createRange();
      range.selectNodeContents(character.el);
      range.collapse(line.n === 0);
      var rect = range.getBoundingClientRect();
      var x = rect.left;
      if (!rect.height) {
        rect = character.el.getBoundingClientRect();
        x = line.n === 0 ? rect.left : rect.right;
      }
      var bounds = root.getBoundingClientRect();
      var fontSize = parseFloat(window.getComputedStyle(line.el).fontSize) || 26;
      var height = fontSize * 0.95;
      state.caret.style.height = height + 'px';
      state.caret.style.left = (x - bounds.left + root.scrollLeft - root.clientLeft + 2) + 'px';
      state.caret.style.top = (rect.top - bounds.top + root.scrollTop - root.clientTop + (rect.height - height) / 2) + 'px';
    }

    function finish(immediately) {
      clearTimers();
      state.finished = true;
      state.lines.forEach(function (line) {
        line.n = line.chars.length;
        line.chars.forEach(function (character) { character.el.classList.add('is-typed'); });
      });
      root.classList.remove('is-pending', 'is-typing');
      unlock();
      if (!state.caret || immediately) {
        if (state.caret) state.caret.classList.add('is-gone');
        removeListeners();
        return;
      }
      state.caret.classList.add('is-idle');
      schedule(function () {
        state.caret.classList.add('is-gone');
        removeListeners();
      }, 1800);
    }

    function motionChanged(event) {
      if (event.matches && !state.destroyed) finish(true);
    }

    function charDelay(line) {
      var ch = line.chars[line.n - 1].text;
      var next = line.chars[line.n] ? line.chars[line.n].text : '';
      var delay = 55 + Math.random() * 85;
      if (ch === ',') delay += 420;
      else if (ch === '.') delay += 650;
      else if (ch === ' ') delay += 20 + Math.random() * 60;
      if (next === ' ' && Math.random() < 0.12) delay += 140;
      if (Math.random() < 0.05) delay += 180 + Math.random() * 220;
      return delay / speed;
    }

    function step() {
      if (state.finished) return;
      var line = state.lines[state.lineIndex];
      while (line && line.n >= line.chars.length) {
        state.lineIndex += 1;
        line = state.lines[state.lineIndex];
      }
      if (!line) {
        state.lineIndex = Math.max(0, state.lines.length - 1);
        finish(false);
        return;
      }

      line.chars[line.n].el.classList.add('is-typed');
      line.n += 1;
      state.caret.classList.remove('is-idle');
      positionCaret();
      var atEnd = line.n >= line.chars.length;
      var delay = atEnd ? (LINE_PAUSE[state.lineIndex] || 0) / speed : charDelay(line);
      if (delay > 300) schedule(function () { state.caret.classList.add('is-idle'); }, 120);
      schedule(step, delay);
    }

    function begin() {
      if (state.destroyed || state.finished || state.started) return;
      if (!root.isConnected) { state.destroy(); return; }
      state.started = true;
      while (state.lines[state.lineIndex] && !state.lines[state.lineIndex].chars.length) state.lineIndex += 1;
      if (!state.lines[state.lineIndex]) { finish(true); return; }
      state.caret.classList.remove('is-gone');
      positionCaret();
      schedule(step, startDelay);
    }

    state.destroy = function () {
      if (state.destroyed) return;
      restore();
      state.destroyed = true;
      instances.delete(root);
      delete root.dataset.twInit;
    };

    try {
      var nodes = Array.from(root.querySelectorAll('[data-line]'));
      state.lines = nodes.map(function (element) {
        return { el: element, text: element.getAttribute('data-line') || '', chars: [], n: 0 };
      });
      if (motion && motion.matches) {
        root.classList.remove('is-pending', 'is-typing');
        unlock();
        state.finished = true;
        return;
      }

      root.classList.add('is-typing');
      root.classList.remove('is-pending');
      state.blocked = true;
      if (link) {
        link.classList.remove('is-live');
        link.setAttribute('tabindex', '-1');
        link.setAttribute('aria-disabled', 'true');
        link.addEventListener('click', blockClick, true);
        link.addEventListener('auxclick', blockClick, true);
      }

      state.lines.forEach(function (line) {
        var fragment = document.createDocumentFragment();
        (line.text.match(/\s+|\S+/g) || []).forEach(function (word) {
          var container = fragment;
          if (!/^\s+$/.test(word)) {
            container = document.createElement('span');
            container.className = 'lpl-tw__word';
            container.setAttribute('aria-hidden', 'true');
            fragment.appendChild(container);
          }
          characters(word).forEach(function (text) {
            var character = document.createElement('span');
            character.setAttribute('data-char', '');
            character.setAttribute('aria-hidden', 'true');
            character.textContent = text;
            container.appendChild(character);
            line.chars.push({ el: character, text: text });
          });
        });
        line.el.replaceChildren(fragment);
      });

      state.caret = document.createElement('span');
      state.caret.className = 'lpl-tw__caret is-idle is-gone';
      state.caret.setAttribute('aria-hidden', 'true');
      root.appendChild(state.caret);
      window.addEventListener('resize', positionCaret, { passive: true });
      if (motion) {
        if (motion.addEventListener) motion.addEventListener('change', motionChanged);
        else if (motion.addListener) motion.addListener(motionChanged);
      }

      if (document.fonts && document.fonts.ready) {
        // Never leave navigation unavailable if a font request stalls indefinitely.
        schedule(function () { if (!state.started) restore(); }, 5000);
        document.fonts.ready.then(function () {
          try { begin(); } catch (error) { restore(); }
        }, restore);
      } else begin();
    } catch (error) {
      restore();
    }
  }

  function rootsWithin(scope) {
    var roots = Array.from(scope.querySelectorAll('[data-lpl-typewriter]'));
    if (scope.matches && scope.matches('[data-lpl-typewriter]')) roots.unshift(scope);
    return roots;
  }

  function boot(scope) {
    rootsWithin(scope || document).forEach(init);
  }

  window.LPLIntroTypewriter = { boot: boot };
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    rootsWithin(event.target).forEach(function (root) {
      var instance = instances.get(root);
      if (instance) instance.destroy();
    });
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
  } else boot(document);
})();
